export default __webpack_public_path__ + "static/media/63.e03f1965.jpg";